import { Box, Stack, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { BizmedAiMarkdown } from "src/utils/markdown";
import { PatientAiAnalysisReport } from "./types";

interface PatientAiAnalysisResultProps {
  report: PatientAiAnalysisReport;
  isStreaming?: boolean;
}

export default function PatientAiAnalysisResult({
  report,
  isStreaming = false,
}: Readonly<PatientAiAnalysisResultProps>) {
  const hasText = Boolean(report.text?.trim());

  return (
    <Stack spacing={2.25} sx={{ pt: 3 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ color: "#94a0ae" }}>
        <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />
        <Typography sx={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>
          Analiz Sonucu
        </Typography>
      </Stack>

      <Box
        className="patient-ai-analysis-md"
        sx={{
          borderRadius: 3,
          border: "1px solid #e7edf3",
          backgroundColor: "#f8fbff",
          p: 2.25,
          boxShadow: "0 16px 40px rgba(15, 23, 42, 0.05)",
        }}
      >
        {hasText ? (
          <BizmedAiMarkdown markdown={report.text} variant="clinical" />
        ) : (
          <Typography sx={{ fontSize: 14, lineHeight: 1.75, color: "#455468" }}>—</Typography>
        )}
        {isStreaming && (
          <Typography sx={{ fontSize: 12, color: "#94a0ae", mt: 1.5, fontStyle: "italic" }}>
            Metin güncelleniyor…
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
